import React from 'react';

import GroupCommissions  from 'components/Tvendo/Sale/QuotaBPartner/ReglaParametro/GroupCommission/List.js';

export default function () {
  return <GroupCommissions  />;
}